export const ResolvedImage = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="150.7"
		height="106.5"
		fill="none"
		preserveAspectRatio="none"
		viewBox="0 0 145 110"
	>
		<path
			fill="#fff"
			d="M5.968 26.013c-2.77 1.85-4.14 5.48-3.53 8.76s3.03 6.1 6.07 7.46 6.63 1.32 9.76.17 5.82-3.35 7.82-6.02"
		/>
		<path
			stroke="#000"
			strokeMiterlimit="10"
			strokeWidth=".98"
			d="M5.968 26.013c-2.77 1.85-4.14 5.48-3.53 8.76s3.03 6.1 6.07 7.46 6.63 1.32 9.76.17 5.82-3.35 7.82-6.02"
		/>
		<path
			fill="#000"
			stroke="#000"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth=".98"
			d="m54.342 63.134-37.39 5.23-1.32-1.99 39.5-6.69z"
		/>
		<path
			fill="#eff5fe"
			stroke="#000"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth=".98"
			d="m53.465 52.533 1.1 10.06-37.81 5.17-.89-10.54 4.22-.58c4.18-.57 10.09-2.29 9.56-7.1l-2.43-22.24 7.22-.99 2.48 22.68c.52 4.8 4.01 5.24 8.19 4.67l8.37-1.14z"
		/>
		<path
			fill="#000"
			d="M35.989 44.793c-.43-.07-2.01-.26-3.56.71-2 1.25-2.34 3.42-2.39 3.73l-.69-5.17 6.43-.88.2 1.61z"
		/>
		<path
			fill="#eff5fe"
			stroke="#000"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth=".98"
			d="m42.438 31.333.03.22c.22 2.08-.41 3.97-1.64 5.54-.03.04-.05.07-.09.1-1.77 2.18-4.73 3.72-8.19 4.18-5.08.69-9.56-.88-11.16-4.7-.1-.26-.2-.52-.28-.79-.13-.44-.23-.9-.28-1.38-.5-4.55 3.03-8.87 8.12-10.26.56-.15 1.12-.27 1.71-.35 1.26-.17 2.48-.16 3.64.03 1.02.15 1.97.44 2.86.82 2.83 1.25 4.87 3.62 5.28 6.58z"
		/>
		<path
			fill="#eff5fe"
			stroke="#000"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth=".98"
			d="m37.95 43.394-9.78 1.34c-.7.1-1.35-.4-1.44-1.1l-.14-1.09a1.3 1.3 0 0 1 1.11-1.45l9.78-1.34c.7-.1 1.35.4 1.44 1.1l.14 1.09a1.3 1.3 0 0 1-1.11 1.45M55.709 62.423l-40.07 5.47-1.13-10.62 40.07-5.48z"
		/>
		<path
			fill="#000"
			stroke="#000"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth=".98"
			d="m55.702 62.423-40.07 5.47-.22-3.22 40.07-5.47z"
		/>
		<path
			fill="#fff"
			d="M29.087 32.013c1.245-1.818 1.3-3.945.125-4.75-1.176-.804-3.138.017-4.383 1.836-1.244 1.818-1.3 3.945-.124 4.75s3.138-.017 4.382-1.836"
		/>
		<path
			fill="#fff"
			d="M17.772 7.853c-5.82-.67-11.36 1.78-14.01 6.26-3.25 5.51-.68 11.62-.05 13.13 1.75 4.17 4.74 6.35 6.58 7.8 3.46 2.75 7.9 4.89 12.21 3.9 1.07-.25 2.13-.7 2.91-1.48.78-.77 1.27-1.9 1.09-2.99-.2-1.23-1.15-2.17-2.05-3.03-2.07-1.97-5.33-4.73-9.6-9.14"
		/>
		<path
			stroke="#000"
			strokeMiterlimit="10"
			strokeWidth=".98"
			d="M17.772 7.853c-5.82-.67-11.36 1.78-14.01 6.26-3.25 5.51-.68 11.62-.05 13.13 1.75 4.17 4.74 6.35 6.58 7.8 3.46 2.75 7.9 4.89 12.21 3.9 1.07-.25 2.13-.7 2.91-1.48.78-.77 1.27-1.9 1.09-2.99-.2-1.23-1.15-2.17-2.05-3.03-2.07-1.97-5.33-4.73-9.6-9.14"
		/>
		<path
			fill="#fff"
			stroke="#000"
			strokeMiterlimit="10"
			strokeWidth=".98"
			d="M36.736 13.273c.54-.74 1.02-1.7.64-2.53-.43-.94-1.67-1.12-2.7-1.15-3.18-.07-6.36.16-9.49.68-1.55.26-3.12.6-4.51 1.35s-2.59 1.97-3 3.49c-.41 1.5.07 3.25 1.3 4.22 1.83 1.44 7.02.06 9.16-.43 3.4-.78 6.54-2.78 8.61-5.62z"
		/>
		<path
			fill="#fff"
			d="M82.824 57.174c-3.2-4.29-8.94-11.52-16.14-18.09-2.53-2.31-6.1-5.31-11.36-7.07-2.37-.79-3.59-1.19-5.33-1.05-6.01.49-8.61 6.65-11.83 5.56-1.43-.48-2.17-2.13-2.38-3.14-.45-2.28 1.23-4.32 2.61-6.03 6.95-8.64 9.84-10.35 9.32-11.86-.45-1.29-2.89-1.19-14.11-1.47-7.23-.19-9.48-.55-10.07.69-.97 2.02 3.27 6.69 5.45 12.1.19.48.55 1.68.43 3.18-.09 1.07-.55 2.15-1.42 2.79-1.54 1.12-3.72.47-5.4-.43-6.39-3.41-10.96-10.02-11.9-17.2-.4-3.02.27-4.65.93-5.71 1.45-2.33 4.27-3.25 4.93-3.46 18.13-5.93 32.02-3.91 32.02-3.91 27.2 3.97 56.47 23.8 61.25 27.08"
		/>
		<path
			stroke="#000"
			strokeMiterlimit="10"
			strokeWidth=".98"
			d="M82.824 57.174c-3.2-4.29-8.94-11.52-16.14-18.09-2.53-2.31-6.1-5.31-11.36-7.07-2.37-.79-3.59-1.19-5.33-1.05-6.01.49-8.61 6.65-11.83 5.56-1.43-.48-2.17-2.13-2.38-3.14-.45-2.28 1.23-4.32 2.61-6.03 6.95-8.64 9.84-10.35 9.32-11.86-.45-1.29-2.89-1.19-14.11-1.47-7.23-.19-9.48-.55-10.07.69-.97 2.02 3.27 6.69 5.45 12.1.19.48.55 1.68.43 3.18-.09 1.07-.55 2.15-1.42 2.79-1.54 1.12-3.72.47-5.4-.43-6.39-3.41-10.96-10.02-11.9-17.2-.4-3.02.27-4.65.93-5.71 1.45-2.33 4.27-3.25 4.93-3.46 18.13-5.93 32.02-3.91 32.02-3.91 27.2 3.97 56.47 23.8 61.25 27.08"
		/>
		<path
			fill="#fff"
			d="M66.369 60.793c.44-6.59 4.73-12.78 10.75-15.49s13.5-1.84 18.73 2.19c-3.17-5.49-1.33-13.3 3.95-16.8s13.19-2.15 17.01 2.91c-.66-6.59 2.18-13.43 7.31-17.62s12.4-5.6 18.73-3.64"
		/>
		<path
			stroke="#000"
			strokeMiterlimit="10"
			strokeWidth=".98"
			d="M66.369 60.793c.44-6.59 4.73-12.78 10.75-15.49s13.5-1.84 18.73 2.19c-3.17-5.49-1.33-13.3 3.95-16.8s13.19-2.15 17.01 2.91c-.66-6.59 2.18-13.43 7.31-17.62s12.4-5.6 18.73-3.64"
		/>
		<path
			fill="#fff"
			d="M102.032 60.173c0 8.22-8.67 7.64-18.31 7.64s-16.59.58-16.59-7.64 7.81-14.88 17.45-14.88 17.45 6.66 17.45 14.88"
		/>
		<path
			fill="#000"
			stroke="#fff"
			strokeMiterlimit="10"
			strokeWidth=".98"
			d="M38.696 105.247c8.575-2.434 14.4-8.37 13.013-13.258s-9.464-6.876-18.04-4.442c-8.574 2.435-14.4 8.371-13.012 13.26 1.388 4.887 9.464 6.875 18.039 4.44Z"
		/>
		<path
			stroke="#000"
			strokeMiterlimit="10"
			strokeWidth=".98"
			d="M39.233 107.124c9.828-2.79 16.433-9.855 14.75-15.78-1.681-5.923-11.013-8.463-20.841-5.672-9.83 2.79-16.433 9.855-14.751 15.78 1.682 5.922 11.013 8.462 20.842 5.672Z"
		/>
		<path
			stroke="#fff"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="1.4"
			d="m32.228 93.495.678 8.082 14.468-14.01"
		/>
	</svg>
);
